import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedAdminPlansRoute extends Route {
  @service declare store: StoreService;

  includes = ['plans'];

  async model(params: { company_id: string }) {
    const { content } = (await this.store.request(
      findRecord<CompanyModel>('company', params.company_id, {
        include: this.includes,
        backgroundReload: true,
      })
    )) as { content: { data: CompanyModel } };
    return content.data;
  }
}
